import React from 'react';
import Spinner, { SpinnerProps } from './Spinner';

interface Props {
  spinnerProps?: SpinnerProps;
}

export default function SpinnerFullPage({ spinnerProps }: Props): JSX.Element {
  return (
    <div className='mt-32 flex justify-center'>
      <Spinner size='full-page' {...spinnerProps} />
    </div>
  );
}
